import { SectionHeader } from "./SectionHeader";

const BENEFITS = [
  "Control de ingresos", "Control de gastos", "Inventario automático",
  "Reportes inteligentes", "Ventas a crédito", "Recordatorios", "PWA instalable",
];

export default function Benefits({ C }) {
  return (
    <section style={{ padding: "64px 20px", maxWidth: 900, margin: "0 auto" }}>
      <SectionHeader C={C} eyebrow="Beneficios" title="Pensado para negocios que quieren crecer" />
      <div className="cq-grid-2" style={{ display: "grid", gap: 12, marginTop: 32 }}>
        {BENEFITS.map((b, i) => (
          <div key={b} style={{
            display: "flex", alignItems: "center", gap: 10,
            background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: 14,
            padding: "14px 16px", animation: `fadeIn 0.4s ease ${i * 0.04}s backwards`,
          }}>
            <div style={{
              width: 24, height: 24, borderRadius: "50%", flexShrink: 0,
              background: `${C.primary}18`, color: C.primary,
              display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13,
            }}>✔</div>
            <span style={{ color: C.text, fontWeight: 600, fontSize: 14 }}>{b}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
